import request from '@/utils/request'

/**
 * 获取地区列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/area.listAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取商铺类型列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function queryShopType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加商家和店铺
 * @param {Object} data 商家数据
 * @returns {Promise}
 */
export function adminAddStoreAndShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.adminAddStoreAndShop',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}